import { render, staticRenderFns } from "./CategoryMenuFoodCard.vue?vue&type=template&id=74742855&scoped=true"
import script from "./CategoryMenuFoodCard.vue?vue&type=script&lang=js"
export * from "./CategoryMenuFoodCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuFoodCard.vue?vue&type=style&index=0&id=74742855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74742855",
  null
  
)

export default component.exports